import type { LucideIcon } from 'lucide-react';
import { CollectionEmptyState } from './CollectionStates';

interface DataTableEmptyRowProps {
  colSpan: number;
  icon: LucideIcon;
  title: string;
}

export function DataTableEmptyRow({ colSpan, icon, title }: DataTableEmptyRowProps) {
  return (
    <tr>
      <td colSpan={colSpan} className="py-16 text-center">
        <CollectionEmptyState icon={icon} title={title} />
      </td>
    </tr>
  );
}
